export const METRICS_TEXT_MAP: any = {
  'appannie_revenue': ['dbi_info_genreprofile_revenue_tip'],
  'appannie_annie_revenue': ['dbi_info_genreprofile_revenue_tip'],
  'sensortower_revenue': ['dbi_info_sensortower_revenue_tip'],
  'sensortower_sensor_revenue': ['dbi_info_sensortower_revenue_tip'],
  'appannie_downloads': ['dbi_info_appannie_downloads_tip'],
  'appannie_annie_download': ['dbi_info_appannie_downloads_tip'],
  'appannie_download': ['dbi_info_appannie_downloads_tip'],
  'sensortower_downloads': ['dbi_info_sensortower_downloads_tips'],
  'sensortower_sensor_download': ['dbi_info_sensortower_downloads_tips'],
  'sensortower_download': ['dbi_info_sensortower_downloads_tips'],
  'appannie_annie_mau': ['dbi_info_appannie_mau_tip'],
  'sensortower_sensor_mau': ['dbi_info_sensortower_mau_tip'],
  '_total_revenue': ['dbi_info_total_revenue'],
  'databrain_pheat': ['dbi_info_pheat_the_predicted_value'],
  'mscience_digital_revenue': ['dbi_info_digital_revenue_tip'],
  'npd_physical_revenue': ['dbi_info_physical_revenue_tip'],
  'newzoo_mau': ['dbi_info_newzoo_mau_tip']
}
